import { render, staticRenderFns } from "./le_tp_shape_model.vue?vue&type=template&id=a12a7508&scoped=true&"
import script from "./le_tp_shape_model.vue?vue&type=script&lang=js&"
export * from "./le_tp_shape_model.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a12a7508",
  null
  
)

export default component.exports